/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadingEntry } from './ReadingEntry';
import {
    ReadingEntryFromJSON,
    ReadingEntryFromJSONTyped,
    ReadingEntryToJSON,
    ReadingEntryToJSONTyped,
} from './ReadingEntry';

/**
 * 
 * @export
 * @interface SectionAnswerDto
 */
export interface SectionAnswerDto {
    /**
     * 
     */
    sectionId?: string;
    /**
     * 
     */
    sectionType?: SectionAnswerDtoSectionTypeEnum;
    /**
     * 
     */
    statusValue?: SectionAnswerDtoStatusValueEnum;
    /**
     * 
     */
    numericValue?: number;
    /**
     * 
     */
    textValue?: string;
    /**
     * 
     */
    readings?: Array<ReadingEntry>;
    /**
     * 
     */
    computedAverage?: number;
    /**
     * 
     */
    notes?: string;
}


/**
 * @export
 */
export const SectionAnswerDtoSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT',
    MultiValue: 'MULTI_VALUE',
} as const;
export type SectionAnswerDtoSectionTypeEnum = typeof SectionAnswerDtoSectionTypeEnum[keyof typeof SectionAnswerDtoSectionTypeEnum];

/**
 * @export
 */
export const SectionAnswerDtoStatusValueEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    Warning: 'WARNING',
    NotApplicable: 'NOT_APPLICABLE',
} as const;
export type SectionAnswerDtoStatusValueEnum = typeof SectionAnswerDtoStatusValueEnum[keyof typeof SectionAnswerDtoStatusValueEnum];


/**
 * Check if a given object implements the SectionAnswerDto interface.
 */
export function instanceOfSectionAnswerDto(value: object): value is SectionAnswerDto {
    return true;
}

export function SectionAnswerDtoFromJSON(json: any): SectionAnswerDto {
    return SectionAnswerDtoFromJSONTyped(json, false);
}

export function SectionAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionAnswerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'statusValue': json['statusValue'] == null ? undefined : json['statusValue'],
        'numericValue': json['numericValue'] == null ? undefined : json['numericValue'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'readings': json['readings'] == null ? undefined : ((json['readings'] as Array<any>).map(ReadingEntryFromJSON)),
        'computedAverage': json['computedAverage'] == null ? undefined : json['computedAverage'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function SectionAnswerDtoToJSON(json: any): SectionAnswerDto {
    return SectionAnswerDtoToJSONTyped(json, false);
}

export function SectionAnswerDtoToJSONTyped(value?: SectionAnswerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionId': value['sectionId'],
        'sectionType': value['sectionType'],
        'statusValue': value['statusValue'],
        'numericValue': value['numericValue'],
        'textValue': value['textValue'],
        'readings': value['readings'] == null ? undefined : ((value['readings'] as Array<any>).map(ReadingEntryToJSON)),
        'computedAverage': value['computedAverage'],
        'notes': value['notes'],
    };
}

